// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface IParticipantAccountActivitySummaryRecordDto
 */
export interface IParticipantAccountActivitySummaryRecordDto {
    /**
     * 
     * @type {string}
     * @memberof IParticipantAccountActivitySummaryRecordDto
     */
    plan_year?: string;
    /**
     * 
     * @type {string}
     * @memberof IParticipantAccountActivitySummaryRecordDto
     */
    plan_name?: string;
    /**
     * 
     * @type {number}
     * @memberof IParticipantAccountActivitySummaryRecordDto
     */
    number_active_accounts?: number;
    /**
     * 
     * @type {number}
     * @memberof IParticipantAccountActivitySummaryRecordDto
     */
    number_cancelled_accounts?: number;
    /**
     * 
     * @type {number}
     * @memberof IParticipantAccountActivitySummaryRecordDto
     */
    total_accounts?: number;
    /**
     * 
     * @type {number}
     * @memberof IParticipantAccountActivitySummaryRecordDto
     */
    total_claim_spend?: number;
}

/**
 * Check if a given object implements the IParticipantAccountActivitySummaryRecordDto interface.
 */
export function instanceOfIParticipantAccountActivitySummaryRecordDto(value: object): value is IParticipantAccountActivitySummaryRecordDto {
    return true;
}

export function IParticipantAccountActivitySummaryRecordDtoFromJSON(json: any): IParticipantAccountActivitySummaryRecordDto {
    return IParticipantAccountActivitySummaryRecordDtoFromJSONTyped(json, false);
}

export function IParticipantAccountActivitySummaryRecordDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): IParticipantAccountActivitySummaryRecordDto {
    if (json == null) {
        return json;
    }
    return {
        
        'plan_year': json['plan_year'] == null ? undefined : json['plan_year'],
        'plan_name': json['plan_name'] == null ? undefined : json['plan_name'],
        'number_active_accounts': json['number_active_accounts'] == null ? undefined : json['number_active_accounts'],
        'number_cancelled_accounts': json['number_cancelled_accounts'] == null ? undefined : json['number_cancelled_accounts'],
        'total_accounts': json['total_accounts'] == null ? undefined : json['total_accounts'],
        'total_claim_spend': json['total_claim_spend'] == null ? undefined : json['total_claim_spend'],
    };
}

export function IParticipantAccountActivitySummaryRecordDtoToJSON(json: any): IParticipantAccountActivitySummaryRecordDto {
    return IParticipantAccountActivitySummaryRecordDtoToJSONTyped(json, false);
}

export function IParticipantAccountActivitySummaryRecordDtoToJSONTyped(value?: IParticipantAccountActivitySummaryRecordDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'plan_year': value['plan_year'],
        'plan_name': value['plan_name'],
        'number_active_accounts': value['number_active_accounts'],
        'number_cancelled_accounts': value['number_cancelled_accounts'],
        'total_accounts': value['total_accounts'],
        'total_claim_spend': value['total_claim_spend'],
    };
}

